import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  registrationContainer: {
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    color: "#666",
    gap: "24px",
    width: "575px",
    minHeight: "229px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
  },
  form: {
    display: "flex",
    background: "#fff",
    flexDirection: "column",
    "& .MuiOutlinedInput-input": {
      color: "#333",
      '&::placeholder': {
        color: '#666'
      }
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
      color: "#333",
      '&::placeholder': {
        color: '#666'
      }
    },
    "& h5": {
      padding: 0,
      marginBottom: "0.75rem",
      fontSize: "1rem",
      color: "#666",
    },
  },
  title: {
    marginTop: "2rem",
    fontSize: "14px",
    textAlign: "center",
    "& .MuiTypography-body1": {
      fontSize: "14px",
      color: '#666'
    },
    "& h4": {
      fontSize: "20px",
      fontWeight: 700,
    },
  },
  inputContainer: {
    padding: "0 2rem",
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  inputContainerConfirm: {
    textAlign: "center",
    "& .MuiFormControl-root": {
      width: "145px",
      textAlign: "center",
    },
  },
  infoText: {
    fontSize: "12px",
    marginTop: "8px",
  },
  infoTextConfirm: {
    fontSize: "14px",
    marginBottom: "16px",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#fff",
    padding: "16px 24px",
    marginTop: "1rem",
    borderTop: "1px solid #ccc",
    "& .goNext": {
      display: "flex",
      alignItems: "center",
      fontSize: "10px",
      color: "#666666",
      fontWeight: 700,
      gap: "10px",
    },
    "& .goBack": {
      border: "2px solid #26975A",
      color: "#26975A",
      height: "32px",
      "& svg": {
        fontSize: "12px",
      },
    },
    "& .next": {
      background: "#26975A",
      color: "#FFF",
      height: "32px",
    },
    "& .Mui-disabled": {
      background: "#EEE",
      color: "#999",
    },
  },
  resendCodeBtn: {
    background: "#26975A",
  },
  textErrorCode: {
    marginTop: "32px",
  },
  mailIcon: {
    border: "3px solid #26975A",
    width: "64px",
    height: "64px",
    borderRadius: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#26975A",
    "& svg": {
      fontSize: "30px",
    },
  },
}));

export default useStyles;
